import { useCallback, useRef, useState } from 'react';
// Utility hook, to be able to both update component state, and access the
// current state inside (e.g. memoized) functions.
export function useRefState(initialState) {
    const ref = useRef(initialState);
    const [state, setState] = useState(initialState);
    const setRefState = useCallback((update) => {
        /** This is not a perfect check, as T could be a function itself, but
         * React does the same check internally */
        if (typeof update === 'function') {
            const updateFunction = update;
            ref.current = updateFunction(ref.current);
        }
        else {
            ref.current = update;
        }
        setState(ref.current);
    }, []);
    return [state, setRefState, ref];
}
